import Tooltip from '../common/Tooltip/Tooltip';
import { Icon } from '../icon/icon';
import { cn } from '../../utils/string/cn.utils';
import { DIM_GROUP } from '../../three/core/dimension/dimensionTypes';

/** Tên hiển thị (khoá i18n) của các nhóm DIM / lớp hiển thị. */
export const GROUP_LABELS = {
  [DIM_GROUP.OVERALL]: 'Overall',
  [DIM_GROUP.UPPER]: 'Upper cabinets',
  [DIM_GROUP.LOWER]: 'Lower cabinets',
  [DIM_GROUP.DETAIL]: 'Detail',
  [DIM_GROUP.ACCESSORY]: 'Accessories',
};

/**
 * Một dòng: nhãn + dấu (i) giải thích + control bên phải.
 * `stacked`: control nằm dưới nhãn và dàn hết chiều ngang (cho control rộng).
 */
export const Field = ({
  label,
  hint,
  hintPlacement = 'left',
  stacked = false,
  children,
}) => (
  <div
    className={cn(
      'flex gap-8 min-h-[32px]',
      // Không đủ chỗ (vd. bản dịch dài) thì control tự xuống hàng bên dưới nhãn
      stacked ? 'flex-col' : 'flex-wrap items-center justify-between'
    )}
  >
    <div className="flex items-center gap-4 min-w-0">
      {/* Nhãn dài được phép xuống dòng thay vì bị cắt "..." */}
      <span className="text-body-medium text-black-high leading-[18px]">
        {label}
      </span>
      {hint && (
        <Tooltip title={hint} placement={hintPlacement}>
          <span className="w-[16px] h-[16px] shrink-0 flex items-center justify-center text-black-low hover:text-primary-primary cursor-help">
            <Icon.ICInfo />
          </span>
        </Tooltip>
      )}
    </div>
    <div
      className={cn(
        'flex items-center',
        stacked ? 'w-full' : 'justify-end shrink-0 ml-auto'
      )}
    >
      {children}
    </div>
  </div>
);

/** Nhóm nút chọn 1 trong nhiều giá trị. */
export const Segmented = ({ value, options, onChange, fullWidth = false }) => (
  <div
    className={cn(
      'p-[2px] gap-[2px] rounded-[8px] bg-fills-secondary',
      fullWidth ? 'flex w-full' : 'inline-flex'
    )}
  >
    {options.map(opt => (
      <button
        key={opt.value}
        type="button"
        aria-pressed={value === opt.value}
        title={typeof opt.label === 'string' ? opt.label : undefined}
        onClick={() => onChange(opt.value)}
        className={cn(
          // Nhãn dài (bản dịch) không được xuống dòng làm tràn viên thuốc
          'h-[26px] min-w-[34px] px-[8px] rounded-[6px] border-0 cursor-pointer text-body-small',
          'whitespace-nowrap overflow-hidden text-ellipsis',
          // Rộng theo nội dung (flex-auto), không chia đều: nhãn dài vẫn đủ chỗ
          fullWidth && 'flex-auto min-w-0 px-[6px]',
          value === opt.value
            ? 'bg-fills-white text-primary-primary font-semibold shadow-dropshadow2'
            : 'bg-trans text-black-medium hover:text-black-high'
        )}
      >
        {opt.label}
      </button>
    ))}
  </div>
);
